import { useCallback, useMemo, useState } from 'react'

const useShowHide = (initialValue: boolean) => {
    const [visible, setVisible] = useState(initialValue)
    const close = useCallback(() => setVisible(false), [])
    const open = useCallback(() => setVisible(true), [])
    const toggle = useCallback((val?: boolean) => (val !== undefined ? setVisible(val) : setVisible(current => !current)), [])
    const set = useCallback((value: boolean) => setVisible(value), [])

    return useMemo(
        () => ({
            close,
            open,
            toggle,
            set,
            visible
        }),
        [close, open, toggle, set, visible]
    )
}

export type ShowHideHandlers = ReturnType<typeof useShowHide>

export const initial = {
    visible: false,
    open: () => void 0,
    close: () => void 0,
    toggle: () => void 0,
    set: () => void 0
}

export default useShowHide
